import Http from "../../http/client";

export default async (id) => {
  const response = await Http.delete('admin/driver/status/'+id, {
    data: {
      "service": "TRIP",
      "latitude": 0,
      "longitude": 0
    }
  });
  return response.data;
}
